import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Ship from "../Asset/Ship.svg";
import moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { FaShip } from "react-icons/fa";
import { RiShip2Fill } from "react-icons/ri";
import Popover from "react-bootstrap/Popover";
import { DownloadDocument } from "../Actions/ShipViewAPI";
import testIcon from "../Asset/Alcoholtest-icon.jpg"
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";

let userRole = localStorage.getItem("UserRoles");

class ShippingCompanyCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
      currentPage: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  renderPopover(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            Callibration due is expired.
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }


  render() {
    const { arraylist, pageSize, totalRecords } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist && arraylist.length > 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  showShipView = (id) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Details" });
    this.props.history.push(`/Home/Client/Ship/ShipDetails/${id}`);
 
  };
  showCrewVisitorView = (id) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Crew Details" });
    this.props.history.push(`/Home/Client/CrewVisitorDetails/${id}`);

  };
  showcalibrationView = (id) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Device Calibration Due" });
    this.props.history.push(`/Home/Client/Ship/DeviceCalibration/${id}`);
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({
      first: event.first,
    });

    setUpdatedState(event.page + 1);
  }

  renderCardData = () => {
    const { arraylist } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
          return (
            <div
              className="card"
              style={{
                overflow: "hidden",
                position: "relative",
                marginBottom: "5px",
              }}
            >
              <div className="px-3 py-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-12 col-md-12">
                      <div className="row">
                        <div className="col-sm-10 col-md-10 col-10 col-m-auto">
                          <div className="row">
                            <div className="col-sm-4 col-md-4 clo-lg-4">
                              <span>
                                <strong>Ship Name : </strong>
                                <span className="italicFont">
                                  {item?.shipName}
                                </span>
                              </span>
                            </div>
                            <div className="col-sm-5 col-md-5 col-lg-5">
                              <span>
                                <strong>Ship Email : </strong>
                                <span className="italicFont">
                                  {item?.shipMail}
                                </span>
                              </span>
                            </div>
                          
                            <div className="col-sm-3 col-md-3 col-lg-3">
                              <span>
                                <strong>Total Crew Members : </strong>
                                <span className="italicFont">
                             {item?.totalCrewMebers}
                                
                                </span>
                              </span>
                            </div>
                          
                            {userRole === "client" || userRole === "consultant" ? (
                              <div className="col-sm-4 col-md-4 mt-2">
                                <span>
                                  <strong>Next Calibration Due : </strong>
                                  <span className="italicFont">
                                    {moment(item?.nextCalibrationDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </span>
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-sm-2 col-md-2 col-2 col-m-auto text-right">
                          <div className="m10" style={{marginLeft:"10px",MarginTop:"1rem"}}>
                            {item.isAnyExpired?
                              <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderPopover()}
                            >
                          <i
                              className="fa fa-exclamation-triangle click px-2"
                              aria-hidden="true"
                              style={{ color: "#d41616f5", fontSize: "1.6rem" }}
                              onClick={()=>{
                                this.showcalibrationView(item?.shipId)}}
                            ></i>
                            </OverlayTrigger>
                            :""}
                            <img className="click px-1" src={Ship} width={34} height={27} style={{fontSize: "2.2rem",color:"#1E3A8A",marginTop:"-8px"}} onClick={() =>
                              this.showShipView(item?.shipId)}/>                          
                               <i
                            style={{ fontSize: "1.8rem"}}
                            className="fa fa-eye click px-2"
                            aria-hidden="true"
                            onClick={() =>
                              this.showCrewVisitorView(item?.shipId)}
                          ></i>
                    </div>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : "";
  };
}

function mapStateToProps(state) {
  return {
    ShippingCompanyList:state.ShipViewReducer.ShippingCompanyList,
    PrevPos: state.SidePanReducer.PrevPos,
    //BY BALU MOORTHI
    editPOView: state.SidePanReducer.EditPOView || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingCompanyCard)
);
